import confirmPopup from './index.vue'
import Vue from 'vue'

export default {
    name: 'Confirm',
    confirm(config){
        const _props = {config}
        const Instance = new Vue({
            render (h) {
                return h(confirmPopup, {
                    props: _props
                });
            }
        });
    
        const component = Instance.$mount();
        document.body.appendChild(component.$el)
    }
};
